// extracted by mini-css-extract-plugin
module.exports = {"icon":"CampaignNameView_icon__3WqfL","logo":"CampaignNameView_logo__2adTV","title":"CampaignNameView_title__1KO9n"};